import React from 'react'

import PumpEmailAcknowledgeLayout from './pumpEmailAcknowledge/Layout'

const PumpEmailAcknowledgeView = () => {
  return <PumpEmailAcknowledgeLayout />
}

export default PumpEmailAcknowledgeView
